import * as React from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { Views } from "@graylog/server-api";
import { DeleteMenuItem } from "components/bootstrap";
import UserNotification from "util/UserNotification";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
const BulkActions = () => {
  const { t } = useTranslation("search");
  const queryClient = useQueryClient();
  const { selectedEntities, setSelectedEntities } = useSelectedEntities();
  const selectedItemsAmount = selectedEntities == null ? void 0 : selectedEntities.length;
  const onDelete = useCallback(() => {
    if (window.confirm(t("saved_searches.confirm_bulk_delete", { count: selectedItemsAmount }))) {
      Views.bulkDelete({ entity_ids: selectedEntities }).then(({ failures }) => {
        if (failures == null ? void 0 : failures.length) {
          const notDeletedSavedSearchIds = failures.map(({ entity_id }) => entity_id);
          setSelectedEntities(notDeletedSavedSearchIds);
          UserNotification.error(
            t("saved_searches.bulk_delete_partial", {
              count: selectedItemsAmount,
              failed: notDeletedSavedSearchIds.length
            })
          );
        } else {
          setSelectedEntities([]);
          UserNotification.success(
            t("saved_searches.bulk_delete_success", { count: selectedItemsAmount }),
            t("saved_searches.success")
          );
        }
      }).catch((error) => {
        UserNotification.error(t("saved_searches.bulk_delete_error", { error }));
      }).finally(() => {
        queryClient.invalidateQueries({
          queryKey: ["saved-searches", "overview"]
        });
      });
    }
  }, [queryClient, selectedItemsAmount, selectedEntities, setSelectedEntities, t]);
  return /* @__PURE__ */ React.createElement(BulkActionsDropdown, null, /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: onDelete }));
};
export default BulkActions;
